import { render, staticRenderFns } from "./EditEthnography.vue?vue&type=template&id=a96eecc2"
import script from "./EditEthnography.vue?vue&type=script&lang=js"
export * from "./EditEthnography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports